import React, { useEffect, useRef, useState } from "react";
import Topbar from "../components/Topbar";
import Leftbar from "../components/Leftbar";
import { Link } from "react-router-dom";
import { getReservations, deleteReservation, displaySuccess, displayError } from "../Utils/utils";
import { toggleLoader } from "../actions/loader";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { getUserData } from "../actions/userdata";
import "../Gynac/style.css";

const statusClass = (status) => {
  const s = (status || '').toLowerCase();
  if (s === 'completed' || s === 'approved') return 'status-pill status-approved';
  if (s === 'cancelled' || s === 'rejected') return 'status-pill status-rejected';
  return 'status-pill status-pending';
};

const Reservations = (props) => {
  const [users, setUsers] = useState([]);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [playingId, setPlayingId] = useState(null);
  const audioRef = useRef(null);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const togglePlay = (audioUrl, id) => {
    if (playingId === id) {
      audioRef.current?.pause();
      setPlayingId(null);
    } else {
      if (audioRef.current) audioRef.current.pause();
      const newAudio = new Audio(audioUrl);
      newAudio.play().catch(() => alert("Error playing audio."));
      audioRef.current = newAudio;
      setPlayingId(id);
    }
  };

  const getList = async (perPage = count, pageNum = 1, searchQuery = search, status = statusFilter) => {
    props.toggleLoader(true);
    const res = await getReservations(perPage, pageNum, searchQuery, status);
    // console.log('Reservations response:', res);
    setTotal(res?.metadata?.totalPage);
    setPage(res?.metadata?.page);
    setUsers(res?.data || []);
    props.toggleLoader(false);
  };

  const isFirstRun = useRef(true);
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      getList(count, 1, search, statusFilter);
      return;
    }
    const handler = setTimeout(() => {
      getList(count, 1, search, statusFilter);
    }, 400);
    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, statusFilter]);

  const handlePageClick = async (e) => {
    const selectedPage = e.selected + 1;
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    getList(count, selectedPage);
  };

  const handlePerPageChange = (e) => {
    const next = parseInt(e.target.value, 10);
    setCount(next);
    getList(next, 1);
  };

  const opengoogleMap = (lat, long) => {
    window.open(`https://www.google.com/maps?q=${lat},${long}`, "_blank");
  };

  const removeReservation = async () => {
    if (!deleteTarget?._id) return;
    setDeleting(true);
    props.toggleLoader(true);
    try {
      const res = await deleteReservation(deleteTarget._id);
      displaySuccess(res?.data?.message || 'Reservation deleted successfully.');
      setDeleteTarget(null);
      await getList(count, page);
    } catch (error) {
      displayError(error);
    } finally {
      setDeleting(false);
      props.toggleLoader(false);
    }
  };

  const filteredUsers = users || [];

  return (
    <div className="g-sidenav-show bg-gray-100">
      <div id="wrapper">
        <Leftbar />
        <main className="main-content border-radius-lg">
          <Topbar />

          <div className="header bg-primary pb-6">
            <div className="container-fluid">
              <div className="header-body">
                <div className="row align-items-center py-4">
                  <div className="col-lg-6 col-7">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
                      <ol className="breadcrumb breadcrumb-links breadcrumb-dark">
                        <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                        <li className="breadcrumb-item"><a href="#">Reservations</a></li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid mt--6"></div>
          <div className="container-fluid">
            <div className="card gynac-card">
              <div className="gynac-card-header">
                <h3 className="gynac-title">
                  Reservation Listing
                  {/* <span className="gynac-count-chip">
                    {filteredUsers.length}{search || statusFilter !== 'all' ? ` of ${users.length}` : ''}
                  </span> */}
                </h3>

                <div className="gynac-toolbar">
                  <div className="gynac-search">
                    <i className="fas fa-search search-icon" />
                    <input
                      type="text"
                      placeholder="Search booking, customer, patient, service"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div className="gynac-filter">
                    <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                      <option value="all">All status</option>
                      <option value="initiated">Initiated</option>
                      <option value="assigned">Assigned</option>
                      <option value="completed">Completed</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <table className="gynac-table reservations-table">
                  <colgroup>
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '16%' }} />
                    <col style={{ width: '16%' }} />
                    <col style={{ width: '18%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '14%' }} />
                    <col style={{ width: '12%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Booking</th>
                      <th>Customer</th>
                      <th>Service / Provider</th>
                      <th>Consultation</th>
                      <th>Created At</th>
                      <th style={{ textAlign: 'center' }}>Status</th>
                      <th style={{ textAlign: 'center' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUsers.map((user) => {
                      const isVideo = user?.appointment_type === 'video_consult';
                      const providerAddress = user?.provider?.location_address || user?.provider?.address;

                      return (
                        <tr key={user?._id}>
                          <td data-label="Booking">
                            <div style={{ fontWeight: 700, color: '#1f2540' }}>#{user?.booking_number}</div>
                          </td>

                          <td data-label="Customer">
                            <div className="doctor-name" style={{ marginBottom: 2 }}>{user?.user?.full_name || '—'}</div>
                            {user?.user?.phone_number && (
                              <div className="contact-line" style={{ fontSize: '0.78rem' }}>
                                <i className="fas fa-phone fa-flip-horizontal" />{user.user.phone_number}
                              </div>
                            )}
                            {user?.user?.email && (
                              <a href={`mailto:${user.user.email}`} className="doctor-email" style={{ display: 'block' }}>
                                {user.user.email}
                              </a>
                            )}
                          </td>

                          <td data-label="Service / Provider">
                            <div className="doctor-name" style={{ marginBottom: 2 }}>{user?.service?.name || '—'}</div>
                            {user?.provider?.name && (
                              <div className="doctor-email">
                                <i className="fas fa-user-md" style={{ marginRight: 4 }} />
                                {user.provider.name}
                              </div>
                            )}
                            {user?.provider?.email && (
                              <div className="doctor-email" style={{ display: 'block' }}>{user.provider.email}</div>
                            )}
                          </td>

                          <td data-label="Consultation">
                            <div className="doctor-email" style={{ marginBottom: 4 }}>
                              <i className={`fas ${isVideo ? 'fa-video' : 'fa-hospital'}`} style={{ marginRight: 4 }} />
                              {isVideo ? 'Video Consult' : 'Physical Visit'}
                            </div>
                            {!isVideo && providerAddress && (
                              <div className="doctor-email" style={{ whiteSpace: 'normal' }}>{providerAddress}</div>
                            )}
                            {!isVideo && user?.provider?.latitude && (
                              <span
                                className="desc-view-more"
                                onClick={() => opengoogleMap(user.provider.latitude, user.provider.longitude)}
                              >
                                <i className="fas fa-map-marker-alt" style={{ marginRight: 4 }} />
                                View Location
                              </span>
                            )}
                          </td>

                          <td data-label="Created At">
                            <div style={{ fontWeight: 600, color: '#1f2540', whiteSpace: 'normal', overflow: 'visible', textOverflow: 'clip' }}>
                              <i className="far fa-clock" style={{ marginRight: 4 }} />
                              {moment(user?.createdAt).format('DD MMM YYYY, hh:mm A')}
                            </div>
                            {user?.user?.time_zone && (
                              <div className="doctor-email" style={{ whiteSpace: 'normal', overflow: 'visible', textOverflow: 'clip' }}>
                                ({user.user.time_zone})
                              </div>
                            )}
                          </td>

                          <td data-label="Status" style={{ textAlign: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'center' }}>
                              <span className={statusClass(user?.status)} style={{ textTransform: 'capitalize' }}>{user?.status}</span>
                              {user?.payment_status && (
                                <span className={statusClass(user.payment_status)} style={{ textTransform: 'capitalize' }}>
                                  {user.payment_status}
                                </span>
                              )}
                              {user?.voice_note && (
                                <button
                                  className="btn-pill btn-approve"
                                  onClick={() => togglePlay(user.voice_note, user._id)}
                                >
                                  <i className={`fas ${playingId === user._id ? 'fa-pause' : 'fa-play'}`} style={{ marginRight: 5, fontSize: '0.7rem' }} />
                                  {playingId === user._id ? 'Pause' : 'Play'} Voice
                                </button>
                              )}
                            </div>
                          </td>

                          <td data-label="Action" style={{ textAlign: 'center' }}>
                            <button
                              className="btn-pill btn-reject"
                              onClick={() => setDeleteTarget(user)}
                            >
                              <i className="fas fa-trash" style={{ marginRight: 5, fontSize: '0.7rem' }} />
                              Delete
                            </button>
                          </td>
                        </tr>
                      );
                    })}

                    {!filteredUsers.length && (
                      <tr>
                        <td colSpan={7}>
                          <div className="gynac-empty">
                            <i className="fas fa-bookmark" />
                            <div className="gynac-empty-text">No reservations found</div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {users.length > 0 && (
                <div className="gynac-footer">
                  <div className="gynac-per-page">
                    <span>Rows per page</span>
                    <select value={count} onChange={handlePerPageChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                    </select>
                  </div>
                  <div className="paginate-css" style={{ margin: 0 }}>
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      breakLabel="..."
                      pageCount={total}
                      forcePage={page > 0 ? page - 1 : 0}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          <Modal
            show={!!deleteTarget}
            onHide={() => !deleting && setDeleteTarget(null)}
            centered
            backdrop="static"
          >
            <Modal.Header style={{ borderBottom: '1px solid #e9ecef' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span
                  style={{
                    width: 40, height: 40, borderRadius: '50%',
                    background: '#fdebec', color: '#c22627',
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 18
                  }}
                >
                  <i className="fas fa-exclamation-triangle" />
                </span>
                <h5 className="mb-0" style={{ fontWeight: 700 }}>Delete reservation?</h5>
              </div>
              <button
                type="button"
                style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1 }}
                onClick={() => !deleting && setDeleteTarget(null)}
                disabled={deleting}
              >
                &times;
              </button>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px 24px', fontSize: '0.95rem', color: '#333' }}>
              Are you sure you want to delete reservation{' '}
              <strong style={{ color: '#1f2540' }}>
                #{deleteTarget?.booking_number || ''}
              </strong>
              ? This action cannot be undone.
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '1px solid #e9ecef' }}>
              <button
                className="btn"
                style={{
                  background: '#fff', border: '1px solid #d0d4e0',
                  color: '#6b7088', borderRadius: 999, fontWeight: 600,
                  padding: '6px 18px'
                }}
                onClick={() => setDeleteTarget(null)}
                disabled={deleting}
              >
                Cancel
              </button>
              <button
                className="btn"
                style={{
                  background: '#c22627', color: '#fff',
                  border: '1px solid #c22627', borderRadius: 999, fontWeight: 600,
                  padding: '6px 18px',
                  opacity: deleting ? 0.7 : 1,
                  cursor: deleting ? 'not-allowed' : 'pointer'
                }}
                onClick={removeReservation}
                disabled={deleting}
              >
                <i className="fas fa-trash" style={{ marginRight: 6, fontSize: '0.78rem' }} />
                {deleting ? 'Deleting…' : 'Confirm'}
              </button>
            </Modal.Footer>
          </Modal>
        </main>
      </div>
    </div>
  );
};

const mapDispatchToProps = { toggleLoader, getUserData };
const mapStateToProps = (state) => ({ userdata: state.userdata?.userData });
export default connect(mapStateToProps, mapDispatchToProps)(Reservations);
